<div class="v3ndor-feature-wrapper" [ngClass]="currentThemeClass()">
  <div class="v-page-content">
    <app-advanced-grid
      stateKey="bwUsersGrid_v1"
      [data]="rows"
      [columns]="columns"
      [config]="gridConfig"
      [loading]="loading"
      [selectable]="true"
      selectionKey="id"
      [selection]="selectedBwUserIds"
      (selectionChange)="onSelectionChange($event)"
      (rowSelect)="onRowClicked($event)"
      (actionClick)="onActionClick($event)">
      <div gridToolbarActions class="flex align-items-center gap-2">
        <button
          type="button"
          class="bw-user-grid-btn"
          [class.--warning]="showInactive"
          [title]="showInactive ? 'Mostrando também os inativos' : 'Mostrando apenas os ativos'"
          (click)="toggleInactive()">
          <i class="pi" [class.pi-eye]="showInactive" [class.pi-eye-slash]="!showInactive"></i>
          <span>{{ showInactive ? 'Ativos e inativos' : 'Somente ativos' }}</span>
        </button>
        @if (isEnableNewUser) {
          <button type="button" class="bw-user-grid-btn --primary" (click)="openNewUserForm()">
            <i class="pi pi-plus" aria-hidden="true"></i>
            <span>Novo usuário</span>
          </button>
        }
        @if (userCanWrite && selectedBwUserIds.length) {
          <button type="button" class="bw-user-grid-btn --warning" (click)="openBulkMaintenance()">
            <i class="pi pi-pencil" aria-hidden="true"></i>
            <span>Manutenção ({{ selectedBwUserIds.length }})</span>
          </button>
        }
      </div>
    </app-advanced-grid>
  </div>
</div>

<app-bw-user-bulk-maintenance
  [(visible)]="bulkMaintenanceVisible"
  [bwUsers]="selectedForBulkMaintenance"
  (bwUserRemoved)="onBulkMaintenanceRemove($event)"
  (done)="onBulkMaintenanceDone($event)"></app-bw-user-bulk-maintenance>

<patron-modal
  [visible]="newUserModalVisible"
  title="Criar usuário"
  confirmButtonText="Salvar"
  (confirm)="newUserForm.submitForm()"
  (cancel)="cancelCreate()"
  cancelButtonText="Cancelar"
  [scrollable]="false"
  [confirmButtonLoading]="saving">
  <patron-form [formGroup]="newUserFormGroup" (onSubmit)="create()" #newUserForm>
    @if (showNoLicenseWarning) {
      <patron-alert color="warning" class="mb-3 d-block">
        Este grupo empresa tem o controle de licenças de usuário ativo. Sem vincular um assento de
        licença, o usuário criado ficará sem acesso ao sistema.
      </patron-alert>
    }

    <patron-form-field
      [formGroup]="newUserFormGroup"
      formControlName="email"
      label="E-mail"
      (handleBlur)="findByEmail($event)">
    </patron-form-field>

    @if (!currentBwUser) {
      <patron-form-field
        [formGroup]="newUserFormGroup"
        formControlName="name"
        label="Nome"></patron-form-field>
    }

    @if (!currentBwUser) {
      <patron-form-field
        [formGroup]="newUserFormGroup"
        type="password"
        formControlName="password"
        label="Senha">
      </patron-form-field>
    }

    @if (!currentBwUser) {
      <patron-form-field
        [formGroup]="newUserFormGroup"
        type="password"
        formControlName="confirm"
        label="Repita a senha">
      </patron-form-field>
    }

    @if (!currentBwUser) {
      <patron-select
        [multiple]="true"
        [formGroup]="newUserFormGroup"
        formControlName="bw_user_profiles"
        bindLabel="name"
        label="Perfis"
        modelName="profiles"
        [addItemProperties]="profilesAddItemProperties"
        [findOptions]="profilesFindOptions">
      </patron-select>
    }

    @if (canLinkLicense) {
      @if (loadingLicenses) {
        <patron-spinner></patron-spinner>
      } @else {
        <div class="mb-3">
          <label class="form-label" for="webLicenseIdSelect">Assento de licença (opcional)</label>
          <select
            id="webLicenseIdSelect"
            class="form-select"
            formControlName="web_license_id">
            <option [ngValue]="null">Não vincular agora</option>
            @for (item of availableLicenses; track item.id) {
              <option [ngValue]="item.id">
                {{ item.vendor_system?.name }} — assento {{ item.number
                }}{{ item.alias ? ' (' + item.alias + ')' : '' }}
              </option>
            }
          </select>
          @if (!availableLicenses.length) {
            <small class="text-muted d-block mt-1">
              Nenhum assento disponível para vincular agora — gere ou libere um em "Licenças de
              usuário".
            </small>
          }
        </div>
      }
    }

    @if (currentBwUser) {
      <patron-alert color="info">
        Usuário já existe <br />
        @if (currentBwUser.name) {
          <strong> {{ currentBwUser.name }} <br /> </strong>
        }
        @if (!bwUserIsLinkedToCurrentCompanyGroup) {
          <span>
            Ao salvar ele será vinculado na empresa
            <strong>
              {{ currentCompanyGroup.name || currentCompanyGroup.alias }}
            </strong>
          </span>
        }
      </patron-alert>
    }
  </patron-form>
  @if (loadingBwUser) {
    <patron-overlay></patron-overlay>
  }
</patron-modal>

<patron-modal
  [visible]="changePasswordModalVisible"
  title="Alterar senha do usuário"
  confirmButtonText="Salvar senha"
  confirmButtonIcon="bi-key"
  (confirm)="changePasswordForm.submitForm()"
  cancelButtonText="Cancelar"
  (cancel)="changePasswordModalVisible = false"
  [scrollable]="false"
  [confirmButtonLoading]="changePasswordSaving">
  <ul patron-list-group class="mb-4">
    <li patron-list-group-item><strong>Nome:</strong> {{ selectedBwUser?.name }}</li>
    <li patron-list-group-item><strong>Email:</strong> {{ selectedBwUser?.email }}</li>
  </ul>

  <patron-form
    [formGroup]="changePasswordFormGroup"
    (onSubmit)="changePassword()"
    #changePasswordForm>
    <patron-form-field
      [formGroup]="changePasswordFormGroup"
      type="password"
      formControlName="password"
      label="Nova senha">
    </patron-form-field>

    <patron-form-field
      [formGroup]="changePasswordFormGroup"
      type="password"
      formControlName="confirm"
      label="Repita a nova senha">
    </patron-form-field>
  </patron-form>

  <patron-alert color="warning">
    <ul>
      <li>A senha será alterada imediatamente.</li>
      <li>
        Ela será marcada como temporária: no próximo acesso o usuário será convidado a definir uma
        senha própria.
      </li>
      <li>Nenhum e-mail é enviado — informe a senha ao usuário por um canal seguro.</li>
    </ul>
  </patron-alert>
</patron-modal>

<patron-modal
  [visible]="resetLinkModalVisible"
  title="Link de redefinição de senha"
  confirmButtonText="Fechar"
  (confirm)="resetLinkModalVisible = false"
  [scrollable]="false">
  <ul patron-list-group class="mb-4">
    <li patron-list-group-item><strong>Nome:</strong> {{ selectedBwUser?.name }}</li>
    <li patron-list-group-item><strong>Email:</strong> {{ selectedBwUser?.email }}</li>
  </ul>

  <patron-alert>
    <span style="word-break: break-all">{{ resetLink }}</span>
  </patron-alert>

  <div class="flex justify-content-center my-3">
    <patron-button
      iconName="pi-copy"
      variant="outline"
      [loading]="loadingCopy"
      (click)="copyResetLink()">
      Copiar link
    </patron-button>
  </div>

  <patron-alert color="warning">
    <ul>
      <li>
        Quem abrir este link entra no painel como
        <strong>{{ selectedBwUser?.name || selectedBwUser?.email }}</strong>
        e é levado a redefinir a senha.
      </li>
      @if (resetLinkExpiresInHours) {
        <li>O link expira em {{ resetLinkExpiresInHours }} horas.</li>
      }
      <li>Compartilhe apenas com o próprio usuário.</li>
    </ul>
  </patron-alert>
</patron-modal>
